import * as types from './mutation-types'

export default {
  [types.ADD_APPLICATIONS](state, applications) {
    state.applications = applications
  },
}
